export const Theme = {
  HIDDEN: 'hidden',
  LIGHT: 'light',
  FILLED: 'filled',
};
